function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0h32v32h-32z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#118623",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "m23 17c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm3.3333333 6.6666667h-2.6666666v2.6666666h-1.3333334v-2.6666666h-2.6666666v-1.3333334h2.6666666v-2.6666666h1.3333334v2.6666666h2.6666666z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.51542 3.00052c.68458 0 1.09486.41028 1.09486 1.0946l.0000319 11.9057972c-.0366974-.0006107-.0734689-.0009172-.1103119-.0009172-2.0135321 0-3.8132273.9155447-5.0055007 2.3530492l-9.1155793.0004708v1.64216l8.1211565-.0002627c-.322144.7708218-.5000765 1.6169231-.5000765 2.5045827 0 1.0593462.2534185 2.0595033.7029393 2.9431553l-11.6085993-.0009953c-.68406 0-1.09434-.4108-1.09434-1.09512v-20.25192c0-.68458.41028-1.09512 1.09434-1.09512zm-3.28406 10.42704h-9.85244v1.64164h9.85244zm0-4.92648h-9.85244v1.64216h9.85244z"
})));

var SvgCreateG = function SvgCreateG(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateG, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/createG.eb7562c2.svg";
export { ForwardRef as ReactComponent };